(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'Authorization',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
		changeCountry();
	});

	form.load = function load($form)
	{
		$form.find('select.client-credit-cards').change(function onCreditCardChange()
		{
			var $self = $(this);

			if ($.trim($self.val())) {
				Adzuki.Ajax.get('/Clients/getClientCreditCardInfo/' + $self.val())
				.then(function populateCreditCardFields(response)
				{
					var cc = response;

					$("#authorization-name_on_card").val(cc.name);
					$("#authorization-address1").val(cc.address1);
					$("#authorization-address2").val(cc.address2);
					$("#authorization-city").val(cc.city);
					$("#authorization-state_id").val(cc.state_id);
					$("#authorization-province").val(cc.state_id);
					$("#authorization-country_id").val(cc.country_id);
					$("#authorization-zip").val(cc.zip);
					$("#authorization-credit_card_type_id").val(cc.credit_card_type_id);
					$("#authorization-credit_card_expiration_month").val(cc.expiration_month);
					$("#authorization-credit_card_expiration_year").val(cc.expiration_year);
					$(".name-on-card").html(cc.name);

					if ($("#authorization-credit_card_number").hasClass('tokens') === false) {
						// only set the cc number to last 4 value if franchise is not storing cc numbers
						$("#authorization-credit_card_number").val(cc.last_four);
					}

					changeCountry();
				});
			} else {
				$("#authorization-name_on_card").val('');
				$("#authorization-address1").val('');
				$("#authorization-address2").val('');
				$("#authorization-city").val('');
				$("#authorization-state_id").val('');
				$("#authorization-country_id").val('183');
				$("#authorization-zip").val('');
				$("#authorization-credit_card_type_id").val('');
				$("#authorization-credit_card_number").val('');
				$("#authorization-ccv").val('');
				$("#authorization-credit_card_expiration_month").val('');
				$("#authorization-credit_card_expiration_year").val('');
				$(".name-on-card").html('');
				changeCountry();
			}
		});

		$form.find('#authorization-country_id').change(changeCountry);

		$('#authorization-name_on_card').change(function onCardholderChange()
		{
			var $self = $(this);

			$(".name-on-card").html($self.val());
		});
	};

	function changeCountry()
	{
		var country_id = $('#authorization-country_id').val();

		if (country_id === '183') {
			$('#authorization-province').val('');
			$('#province-container').addClass('hidden');
			$('#state-container').removeClass('hidden');
		} else if (country_id === '31') {
			$('#authorization-state_id').val('');
			$('#state-container').addClass('hidden');
			$('#province-container').removeClass('hidden');
		} else {
			$('#authorization-state_id').val('');
			$('#state-container').addClass('hidden');
			$('#authorization-province').val('');
			$('#province-container').addClass('hidden');
		}
	}
}(jQuery, window.Adzuki || {}));
